import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, ResolveStart, NavigationCancel } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PlatformService } from '@app/shared/services/platform/platform.service';

@Component({
  selector: 'vc-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  loading = false;
  value = 0;

  constructor(private router: Router, private platformService: PlatformService) {}

  ngOnInit() {
    if (this.platformService.isServer) {
      return;
    }
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(
      (event: NavigationStart) => {
        this.loading = true;
        this.value = this.getRandomArbitrary(0, 50);
      },
      error => console.log(error)
    );
    this.router.events.pipe(filter(event => event instanceof ResolveStart)).subscribe(
      (event: ResolveStart) => {
        this.loading = true;
        this.value = this.getRandomArbitrary(50, 100);
      },
      error => console.log(error)
    );
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(
      (event: ResolveStart) => {
        this.value = 100;
        this.loading = false;
      },
      error => console.log(error)
    );
    this.router.events.pipe(filter(event => event instanceof NavigationCancel)).subscribe(
      (event: ResolveStart) => {
        this.value = 100;
        this.loading = false;
      },
      error => console.log(error)
    );
  }

  getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }
}
